// export default ShopForm;
// https://sakhisshop.com

import React, { useEffect, useState } from "react";
import {
  Typography,
  TextField,
  Button,
  Container,
  Grid,
  Paper,
  Box,
  Divider,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import axios from "axios";
import { motion } from "framer-motion";
import StoreIcon from "@mui/icons-material/Store";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import LockIcon from "@mui/icons-material/Lock";
import InfoIcon from "@mui/icons-material/Info";
import Autocomplete from "@mui/material/Autocomplete";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link as RouterLink } from "react-router-dom";
// Section Title
const SectionHeader = ({ icon, title }) => (
  <Box mt={4} mb={2} display="flex" alignItems="center">
    {icon}
    <Typography variant="h6" fontWeight={600} ml={1}>
      {title}
    </Typography>
    <Divider sx={{ flexGrow: 1, ml: 2 }} />
  </Box>
);

const ShopForm = () => {
  const [rmList, setRmList] = useState([]);
  const [selectedRM, setSelectedRM] = useState();
  const [acceptedPolicy, setAcceptedPolicy] = useState(false);

  const [usernameError, setUsernameError] = useState("");

  const [formData, setFormData] = useState({
    shopname: "",
    owner: "",
    address: "",
    contactNumber: "",
    // feedback: "",
    // ratings: "",
    // productsAvailable: "",
    // discountRack: "",
    // newArrivals: "",
    whatsapp: "",
    upiId: "",
    // advertisement: "",
    shopType: "",
    rmName: "",
    rmContact: "",
    // registrationFee: "",
    username: "",
    password: "",
    // apiKey: "",       // ✅ New
    // secretKey: "",    // ✅ New
    area: "",
    email: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!acceptedPolicy) {
      alert("Please accept the policies before registering the shop.");
      return;
    }

    // if (!selectedRM) {
    //   alert("❌ Please select a Relation Manager.");
    //   return;
    // }

    if (role !== "RM" && !selectedRM) {
      alert("❌ Please select a Relation Manager.");
      return;
    }

    const rmIdValue =
      role === "RM"
        ? Number(rmId)
        : selectedRM && selectedRM.rmId
          ? Number(selectedRM.rmId)
          : null;

    if (!rmIdValue) {
      alert("❌ RM ID missing!");
      return;
    }
    const finalData = {
      shopname: formData.shopname,
      owner: formData.owner,
      address: formData.address,
      contactNumber: formData.contactNumber,
      whatsapp: formData.whatsapp,
      email: formData.email,
      shopType: formData.shopType,
      username: formData.username,
      password: formData.password,
      area: formData.area,
      serviceAreas: formData.serviceAreas || [],

      relationManager: {
        rmId: rmIdValue,
      },
    };

    try {
      console.log("FINAL DATA:", JSON.stringify(finalData, null, 2));
      const response = await axios.post(
        "https://sakhisshop.com/api/shops",

        JSON.stringify(finalData),
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 201) {
        alert("✅ Shop registered successfully!");
        setFormData({
          shopname: "",
          owner: "",
          address: "",
          contactNumber: "",
          whatsapp: "",
          rmContact: "",
          shopType: "",
          username: "",
          password: "",
          area: "",
          email: "",
          serviceAreas: [],
        });
        setSelectedRM(null);
        setAcceptedPolicy(false);
      }
    } catch (error) {
      console.error("❌ Employee registration failed:", error);

      const backendMessage =
        error.response?.data?.error || // backend error
        error.response?.data?.message || // fallback
        "❌ Registration failed. Please try again.";

      // ✅ Inline error ONLY for username
      if (backendMessage.toLowerCase().includes("username")) {
        setUsernameError(backendMessage); // show under Username
        return; // do not show toast
      }

      // ✅ Toast for all other errors
      toast.error(backendMessage);
    }
  };

  const role = localStorage.getItem("role");
  const rmId = localStorage.getItem("rmId");

  useEffect(() => {
    const storedRole = localStorage.getItem("role");

    if (storedRole === "RM") {
      const storedRmName = localStorage.getItem("rmName");
      const storedRmMobile = localStorage.getItem("rmMobile");

      console.log("RM DEBUG:", storedRmName, storedRmMobile);

      setFormData((prev) => ({
        ...prev,
        rmName: storedRmName ? storedRmName : "",
        rmContact: storedRmMobile ? storedRmMobile : "",
      }));
    }
  }, []);
  // useEffect(() => {
  //   const role = localStorage.getItem("role");

  //   if (role === "RM") {
  //     const rmName = localStorage.getItem("rmName");
  //     const rmMobile = localStorage.getItem("rmMobile");

  //     console.log("RM DEBUG:", rmName, rmMobile); // 🔍 check

  //     setFormData((prev) => ({
  //       ...prev,
  //       rmName: rmName || "",
  //       rmContact: rmMobile || "",
  //     }));
  //   }
  // }, []);
  //   useEffect(() => {
  //   axios.get("https://sakhisshop.com/api/rm")
  //     .then((res) => {
  //       console.log("RM API RESPONSE:", res.data); //
  //       // Filter required fields only
  //            const rmArray = Array.isArray(res.data)
  //         ? res.data
  //         : res.data?.data || [];

  //     const cleanedRMList = rmArray.map(rm => ({
  //         rmId: rm.rmId,
  //         name: rm.name,
  //         mobileNo: rm.mobileNo
  //       }));

  //       setRmList(cleanedRMList);
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching RMs:", err);
  //     });
  // }, []);

  return (
    <Box sx={{ background: "#f9f9f9", minHeight: "100vh", py: 6 }}>
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
            <Typography
              variant="h5"
              align="center"
              fontWeight="bold"
              gutterBottom
            >
              🏪 Shop Registration Form
            </Typography>
            <Typography
              variant="body2"
              align="center"
              color="text.secondary"
              mb={3}
            >
              Fill the details carefully. This information will be used to set
              up your shop profile.
            </Typography>

            <form onSubmit={handleSubmit}>
              {/* 🛒 Shop Info */}
              <SectionHeader
                icon={<StoreIcon color="primary" />}
                title="Shop Information"
              />
              <Grid container spacing={2}>
                {[
                  { name: "shopname", label: "Shop Name", required: true },
                  { name: "owner", label: "Owner Name" },
                  { name: "address", label: "Shop Address" },
                ].map(({ name, label, required }) => (
                  <Grid item xs={12} sm={6} key={name}>
                    <TextField
                      fullWidth
                      size="medium"
                      label={label}
                      name={name}
                      value={formData[name]}
                      onChange={handleChange}
                      required={required}
                    />
                  </Grid>
                ))}
              </Grid>

              {/* 📞 Contact Section */}
              <SectionHeader
                icon={<ContactPhoneIcon color="primary" />}
                title="Contact & Marketing"
              />

              <Grid container spacing={2}>
                {/* Contact Number */}
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Contact Number"
                    name="contactNumber"
                    value={formData.contactNumber}
                    onChange={handleChange}
                  />
                </Grid>

                {/* WhatsApp */}
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="WhatsApp"
                    name="whatsapp"
                    value={formData.whatsapp}
                    onChange={handleChange}
                  />
                </Grid>

                {/* Email */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="medium"
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Grid>

                {/* Shop Type */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    // label="Shop Type"
                    name="shopType"
                    value={formData.shopType || ""}
                    onChange={handleChange}
                    required
                    SelectProps={{ native: true }}
                  >
                    <option value="">Select Shop Type</option>
                    <option value="GROCERY">Grocery</option>
                    <option value="SWEET">Sweet Mart</option>
                    <option value="MEAT">Meat Shop</option>
                    <option value="VEGETABLE">Vegetable Shop</option>
                    <option value="BARTAN">Bartan Hub</option>
                    <option value="FISH">Fish Shop</option>
                    <option value="1GM_JEWELRY">1gm Jewelry</option>
                    <option value="DAIRY">Dairy</option>
                  </TextField>
                </Grid>
              </Grid>

              {/* 🗣 Feedback */}
              <SectionHeader
                icon={<InfoIcon color="primary" />}
                title="Areas"
              />
              {/* 🔍 Service Area Section */}

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="medium"
                  label="Area"
                  name="area"
                  value={formData.area}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  📍 Service Areas (You can type or select multiple)
                </Typography>
                <Autocomplete
                  multiple
                  freeSolo
                  fullWidth
                  options={["Kharadi", "Wagholi", "Hadapsar", "Baner", "Pune"]}
                  value={formData.serviceAreas || []}
                  onChange={(event, value) =>
                    setFormData({ ...formData, serviceAreas: value })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Service Areas"
                      placeholder="Start typing area"
                      fullWidth
                    />
                  )}
                />
              </Grid>

              {/* 🧑‍💼 RM Section */}
              {role !== "RM" && (
                <Grid item xs={12}>
                  <Box mt={3}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      gutterBottom
                    >
                      🧑‍💼 Assign Relation Manager
                    </Typography>

                    <Autocomplete
                      fullWidth
                      options={rmList}
                      getOptionLabel={(option) =>
                        option ? `${option.name} (${option.mobileNo})` : ""
                      }
                      value={selectedRM}
                      isOptionEqualToValue={(option, value) =>
                        option.rmId === value?.rmId
                      }
                      onChange={(event, value) => {
                        setSelectedRM(value);

                        if (value) {
                          setFormData((prev) => ({
                            ...prev,
                            rmName: value.name,
                            rmContact: value.mobileNo,
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Relation Manager"
                          required
                        />
                      )}
                    />
                  </Box>
                </Grid>
              )}
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="RM Name"
                    value={formData.rmName || ""}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="RM Contact"
                    value={formData.rmContact || ""}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
              </Grid>
              {/* 🔐 Credentials */}
              <SectionHeader
                icon={<LockIcon color="primary" />}
                title="Credentials"
              />
              <Grid container spacing={2}>
                {/* Username with inline error handling */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="medium"
                    label="Username"
                    name="username"
                    type="text"
                    value={formData.username || ""}
                    onChange={(e) => {
                      setFormData({ ...formData, username: e.target.value });
                      setUsernameError(""); // clear error when typing
                    }}
                    required
                    error={!!usernameError}
                    helperText={usernameError}
                  />
                </Grid>

                {/* Password (normal field) */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="medium"
                    label="Password"
                    name="password"
                    type="password"
                    value={formData.password || ""}
                    onChange={handleChange}
                    required
                  />
                </Grid>
              </Grid>

              <Box
                mt={3}
                sx={{
                  border: "1px solid #d9d9d9",
                  borderRadius: 2,
                  p: 2,
                  backgroundColor: "#fff",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={acceptedPolicy}
                      onChange={(e) => setAcceptedPolicy(e.target.checked)}
                      required
                    />
                  }
                  sx={{ alignItems: "flex-start" }}
                  label={
                    <Typography variant="body1" sx={{ lineHeight: 1.5 }}>
                      I have read and accepted all privacy policy, refund
                      policy, and app usage terms.
                    </Typography>
                  }
                />

                <Typography
                  component={RouterLink}
                  to="/policies-legal"
                  variant="body1"
                  sx={{
                    color: "#2e7d32",
                    fontWeight: 700,
                    textDecoration: "none",
                    ml: 4.5,
                  }}
                >
                  Read policies
                </Typography>
              </Box>

              <Box mt={5} textAlign="center">
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: "1rem",
                    mt: 3,
                    py: 1.5,
                    fontWeight: 600,

                    textTransform: "capitalize",
                  }}
                >
                  REGISTER SHOP
                </Button>
              </Box>
            </form>
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default ShopForm;
